module.exports = __webpack_public_path__ + "static/media/fr-tracing-shot-1.ef861893.png";